import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {deleteReservation as deleteReservationAPI} from '../../../services/groups'

export async function deleteReservation(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await deleteReservationAPI(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Delete Reservation Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
